import React from 'react';

import { Grid, Typography } from '@mui/material';

import ChatRuleMessage from '@common/modules/Chat/Title/Rules/StudentModalContent/Message';
import ContentCard from '@common/modules/Chat/Title/Rules/TeacherModalContent/ContentCard';
import {
	academyData,
	lyceumData,
} from '@common/modules/Chat/Title/Rules/TeacherModalContent/rulesData';

import * as Styled from '../../styled';

function FirstStep() {
	return (
		<>
			<Typography variant="body2">
				Чати на платформі — це новий функціонал, що спрощує комунікацію з питань навчання. Учні
				можуть звернутися до чату, якщо мають запитання щодо матеріалу уроку, змісту домашнього
				завдання або якщо не згодні з оцінкою.
			</Typography>
			<ChatRuleMessage />
			<Typography variant="subtitle2" color="#C41C1C" fontWeight={600}>
				Інші типи запитань, що не стосуються навчального матеріалу, мають бути переспрямовані на:
			</Typography>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<Styled.ColumnWrapper>
						{academyData.map(({ logo, text }, index) => (
							<ContentCard key={index} logo={logo} text={text} as="li" />
						))}
					</Styled.ColumnWrapper>
				</Grid>
				<Grid item xs={6}>
					<Styled.ColumnWrapper>
						{lyceumData.map(({ logo, text }, index) => (
							<ContentCard key={index} logo={logo} text={text} as="li" />
						))}
					</Styled.ColumnWrapper>
				</Grid>
			</Grid>
		</>
	);
}

export default FirstStep;
